import { AlertTriangle, History, UserX } from "lucide-react";
import { STATUS } from "@/lib/helpers";

export const StatusBadge = ({ status }) => (
  <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-bold ${STATUS[status]?.badge}`} data-testid={`status-badge-${status}`}>
    <span className={`w-1.5 h-1.5 rounded-full ${STATUS[status]?.dot}`} />
    {STATUS[status]?.label || status}
  </span>
);

export const Flags = ({ a }) => (
  <span className="inline-flex flex-wrap gap-1">
    {a.conflict && (
      <span className="inline-flex items-center gap-1 rounded-full bg-red-600 px-2 py-0.5 text-[11px] font-bold text-white" data-testid="conflict-flag">
        <AlertTriangle className="w-3 h-3" /> Çakışma
      </span>
    )}
    {a.phone_total > 1 && (
      <span className="inline-flex items-center gap-1 rounded-full bg-sky-100 px-2 py-0.5 text-[11px] font-bold text-sky-900" data-testid="repeat-flag">
        <History className="w-3 h-3" /> {a.phone_total - 1} önceki
      </span>
    )}
    {a.noshow_count > 0 && (
      <span className="inline-flex items-center gap-1 rounded-full bg-slate-700 px-2 py-0.5 text-[11px] font-bold text-white" data-testid="noshow-flag">
        <UserX className="w-3 h-3" /> {a.noshow_count} gelmedi
      </span>
    )}
  </span>
);
